import script from "./lottery-variator.vue?vue&type=script&lang=ts&setup=true"
export * from "./lottery-variator.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__